export default __webpack_public_path__ + "static/media/MHP - 2, PKL3.39a17792.jpg";